import {deserialize, serialize, inheritSerialization, deserializeAs} from "cerialize";

import BaseEntity from "./BaseEntity";
import Soal from "./Soal";

@inheritSerialization(BaseEntity)
export default class JawabanBankSoal extends BaseEntity {

    @serialize
    @deserialize
    public bank_soal_id: number = 0;

    @serialize
    @deserialize
    public nomor: string = "";

    @serialize
    @deserialize
    public nama_lengkap: string = "";

    @serialize
    @deserialize
    public jenis_kelamin: string = "";

    @serialize
    @deserialize
    public orang_tua: string = "";

    @serialize
    @deserialize
    public sekolah_asal: string = "";

    @serialize
    @deserializeAs(Soal)
    public jawabans: Array<Soal> = [];

}